import { createContext } from "react";
import type { AuthUser } from "./types";

export interface AuthContextValue {
  user: AuthUser | null;
  loading: boolean;
  login: (input: { emailOrUsername: string; password: string }) => Promise<AuthUser>;
  signup: (input: { email: string; username: string; password: string; displayName?: string }) => Promise<{ user: AuthUser; recoveryCode: string }>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
  applySession: (user: AuthUser, token: string) => void;
  updateProfile: (input: { displayName?: string | null; email?: string }) => Promise<AuthUser>;
  changePassword: (input: { currentPassword: string; newPassword: string }) => Promise<void>;
  rotateRecovery: () => Promise<string>;
  redeemRecovery: (input: { emailOrUsername: string; recoveryCode: string; newPassword: string }) => Promise<AuthUser>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
